export interface SendMailModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (
    channelId?: string,
    templateId?: string,
    overrides?: Record<string, string>,
  ) => void;
  type: 'cheque' | 'foia';
  isLoading: boolean;
  departmentId: string;
  departmentName: string;
  policeReportId: string;
  matterId: string;
  firmId?: string;
}

export const MODAL_CONFIG = {
  cheque: {
    iconBg: 'bg-purple-100',
    iconColor: 'text-purple-600',
    title: 'Send Cheque by Mail',
    buttonBg: 'bg-purple-600 hover:bg-purple-700',
    message: 'A request letter will be generated and mailed with the cheque.',
  },
  foia: {
    iconBg: 'bg-green-100',
    iconColor: 'text-green-600',
    title: 'Send FOIA Letter',
    buttonBg: 'bg-green-600 hover:bg-green-700',
    message: 'A FOIA request letter will be generated and mailed.',
  },
} as const;
